import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@stockcare-services/authentication/authentication.service';
import { NotificationService } from '@stockcare-services/notification-service/notification.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {
  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private notify: NotificationService
  ) {}

  canActivate(): boolean {
    const token = localStorage.getItem('token');
    if (this.authService.isTokenExpired(token)) {
      this.router.navigate(['']);
      this.notify.warning(
        'Please login with username and password',
        'Pin expired'
      );
      return false;
    }
    return true;
  }
}
